import axios from "axios";
import { API_BASE } from "../../config/env";

export const FETCH_FORGOTPASSWORD_FULFILLED = "FETCH_FORGOTPASSWORD_FULFILLED";
export const FETCH_FORGOTPASSWORD_REJECTED = "FETCH_FORGOTPASSWORD_REJECTED";
export const FETCH_FORGOTPASSWORD_PENDING = "FETCH_FORGOTPASSWORD_PENDING";


function uuidv4() {
    return ([1e7] + -1e3 + -4e3 + -8e3 + -1e11).replace(/[018]/g, (c) =>
        (
            c ^
            (crypto.getRandomValues(new Uint8Array(1))[0] & (15 >> (c / 4)))
        ).toString(16)
    );
}


export function initiateForgotPassword(nationalIdentifier) {
    localStorage.setItem("One-Id", uuidv4())
    localStorage.setItem("Client-Id", uuidv4())
    localStorage.setItem("nationalIdentifier", encodeURIComponent(nationalIdentifier))
    const data = {
        nationalIdentifier: nationalIdentifier,
    }

    const json_data = JSON.stringify(data)
    return (dispatch) => {
        dispatch({
            type: "FETCH_FORGOTPASSWORD",
            payload: axios({
                method: "post",
                url: `${API_BASE}/api/v3/auth/initiate-forgot-password`,
                data: json_data,
                headers: {
                    "Accept-Language": "tr-tr",
                    "Client-Id": localStorage.getItem("Client-Id"),
                    "One-Id": localStorage.getItem("One-Id"),
                    "Content-Type": "application/json",
                    "ngrok-skip-browser-warning": "69920"
                },
            }).then((result) => result.data),
        });
    };
}

export function forgotPassword(nationalIdentifier, verificationCode, password) {
    localStorage.setItem("One-Id", uuidv4())
    localStorage.setItem("Client-Id", uuidv4())
    const data = {
        nationalIdentifier: nationalIdentifier,
        verificationCode: verificationCode,
        password: password
    }

    const json_data = JSON.stringify(data)
    return (dispatch) => {
        dispatch({
            type: "FETCH_FORGOTPASSWORD",
            payload: axios({
                method: "post",
                url: `${API_BASE}/api/v3/auth/complete-forgot-password`,
                data: json_data,
                headers: {
                    "Accept-Language": "tr-tr",
                    "Client-Id": localStorage.getItem("Client-Id"),
                    "One-Id": localStorage.getItem("One-Id"),
                    "Content-Type": "application/json",
                    "ngrok-skip-browser-warning": "69920"
                },
            }).then((result) => result.data),
        });
    };
}

